<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon" :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)"></van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('newSportList.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="weekly" @click="toWeekly">
                <div class="weekly-title">{{ $t('newSportList.type0') }}</div>
                <div class="weekly-range">{{weeklyRange}}</div>
                <img class="weekly-icon" :src="require(`@/assets/theme/light/report/01list/02week.svg`)">
            </div>
            <div class="month" @click="toMonth">
                <div class="weekly-title">{{ $t('newSportList.type1') }}</div>
                <div class="weekly-range">{{monthRange}}</div>
                <img class="weekly-icon" :src="require(`@/assets/theme/light/report/01list/02month.svg`)">
            </div>
            <div class="year" @click="toYear">
                <div class="weekly-title">{{ $t('newSportList.type2') }}</div>
                <div class="weekly-range">{{yearRange}}</div>
                <img class="weekly-icon" :src="require(`@/assets/theme/light/report/01list/02year.svg`)">
            </div>
        </div>
    </div>
</template>

<script>
    import {getQueryVariable} from '@/utils/comment'
    import {getMonthStartDay, GetMonth} from '@/utils/dateUtils'
    import {WebJSBridge} from "../../utils/JSBridge1";
    import {changeMonthDate, getMonthEndDay, getNWeekFirstDay, getNWeekLastDay} from "../../utils/dateUtils";
    export default {
        name: 'list',
        data() {
            return {
                theme: 'light',
                weeklyRange: '',
                monthRange: '',
                yearRange: '',
            }
        },
        mounted() {
            this.theme = this.$route.query.theme ? this.$route.query.theme : 'light';
            if (this.$route.query.token) {
                localStorage.setItem("token", this.$route.query.token);
            }
            this.getMonth();
            this.getWeeklyRange();
            this.getYearRange();
        },
        methods: {
            back() {
                WebJSBridge.call("closeWeb", null, function (res) {
                });
            },
            getMonth() {
                let startDate = getMonthStartDay(-1);
                this.monthRange = changeMonthDate(startDate);
            },
            getWeeklyRange() {
                let startDate = getNWeekFirstDay(-1);
                let endDate = getNWeekLastDay(-1);
                this.weeklyRange = startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + endDate.slice(5, 10).replace(/-/g, '/');
            },
            getYearRange() {
                let date = new Date();
                let year = date.getFullYear();
                let lastYear = year - 1;
                this.yearRange = lastYear;
            },
            toWeekly() {
                this.$router.push({
                    name: 'newWeek',
                    query: {
                        lang: this.$i18n.locale,
                        theme: this.theme
                    }
                })
            },
            toMonth() {
                this.$router.push({
                    name: 'newMonth',
                    query: {
                        lang: this.$i18n.locale,
                        theme: this.theme
                    }
                })
            },
            toYear() {
                this.$router.push({
                    name: 'openYear',
                    query: {
                        lang: this.$i18n.locale,
                        theme: this.theme
                    }
                })
            }
        }
    }
</script>

<style scoped>

    .content {
        width: 100%;
        height: 100%;
        position: relative;
        margin-top: 88px;
    }

    .weekly {
        position: absolute;
        width: 345px;
        height: 86px;
        left: 15px;
        top: 32px;
        background: var(--bg-color-2);
        border-radius: 13px 13px 13px 13px;
    }

    .weekly-title {
        font-size: 15px;
        color: var(--text-color-1);
        position: absolute;
        left: 22px;
        top: 20px;
    }

    .month {
        position: absolute;
        width: 345px;
        height: 86px;
        left: 15px;
        top: 151px;
        background: var(--bg-color-2);
        border-radius: 13px 13px 13px 13px;
    }

    .year {
        position: absolute;
        width: 345px;
        height: 86px;
        left: 15px;
        top: 270px;
        background: var(--bg-color-2);
        border-radius: 13px 13px 13px 13px;
    }

    .weekly-range {
        position: absolute;
        left: 22px;
        top: 50px;
        font-size: 13px;
        color: var(--text-color-2);
    }

    .weekly-icon {
        width: 219px;
        position: absolute;
        right: 0;
        bottom: 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/report/01list.vue